import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Wind, Star, Heart, Users, ArrowRight, MessageCircle, Edit2, Trash2, X, Send, Calendar, Clock, MapPin, Sparkles, Zap, BookOpen, Music2, Flame, HelpingHand } from 'lucide-react';
import ImagesDev from '../../api/images';
import { getUserData } from '../../api/authService';
import { Toast } from '../../components/Toast';
import { EventsHighlights } from '../../components/EventsHighlights';

function LiveInTheSpirit_() {
  const events = [
    {
      title: "Spirit-Led Worship Night",
      date: "March 30, 2024",
      description: "An evening of spontaneous worship and prophetic ministry",
      image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
    },
    {
      title: "Prophetic Conference",
      date: "April 20, 2024",
      description: "Developing sensitivity to the Holy Spirit's leading",
      image: "https://images.unsplash.com/photo-1519677584237-752f8853252e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
    },
    {
      title: "Spiritual Gifts Workshop",
      date: "May 5, 2024",
      description: "Understanding and operating in the gifts of the Spirit",
      image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
    }
  ];

  const testimonials = [
    {
      name: "David Wilson",
      testimony: "This ministry has taught me how to truly walk in the Spirit daily.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    },
    {
      name: "Rachel Thompson",
      testimony: "I've experienced a deeper level of God's presence through these teachings.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      {/* Hero Section */}
      <div className="relative h-[50vh] mb-16">
        <div className="absolute inset-0">
          <img
            src={ImagesDev.litsImg}
            alt="Life in the Spirit"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40" />
        </div>
        <div className="relative container mx-auto px-4 h-full flex items-center">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">Life in the Spirit</h1>
            <p className="text-xl text-gray-300">Experience the supernatural life of walking in the Spirit</p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {/* Core Values */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm text-center">
            <Wind className="w-12 h-12 text-orange-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Spirit-Led Life</h3>
            <p className="text-gray-300">Learning to follow the Holy Spirit's guidance</p>
          </div>
          <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm text-center">
            <Heart className="w-12 h-12 text-orange-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Divine Love</h3>
            <p className="text-gray-300">Walking in supernatural love and compassion</p>
          </div>
          <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm text-center">
            <Star className="w-12 h-12 text-orange-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Spiritual Gifts</h3>
            <p className="text-gray-300">Operating in the gifts of the Spirit</p>
          </div>
          <div className="bg-white/5 p-6 rounded-lg backdrop-blur-sm text-center">
            <Users className="w-12 h-12 text-orange-400 mx-auto mb-4" />
            <h3 className="text-xl font-bold mb-2">Community</h3>
            <p className="text-gray-300">Growing together in spiritual maturity</p>
          </div>
        </div>

        <EventsHighlights parent="life_in_the_spirit" />

        {/* Upcoming Events */}
        {/* <div className="mb-16">
          <h2 className="text-3xl font-bold mb-8">Upcoming Events</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {events.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
                className="bg-white/5 rounded-lg overflow-hidden backdrop-blur-sm"
              >
                <div className="h-48 relative">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-orange-400 mb-2">
                    <Calendar className="w-4 h-4" />
                    <span>{event.date}</span>
                  </div>
                  <h3 className="text-xl font-bold mb-2">{event.title}</h3>
                  <p className="text-gray-300 mb-4">{event.description}</p>
                  <button className="flex items-center gap-2 text-orange-400 hover:text-orange-300 transition-colors">
                    Learn More
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div> */}

        {/* Testimonials */}
        <LiveInTheSpiritComments />
      </div>
    </motion.div>
  );
}

function LiveInTheSpirit_designVersion2_0() {
  const events = [
    {
      title: "Spirit-Led Worship Night",
      date: "March 30, 2024",
      time: "6:00 PM",
      location: "Main Auditorium",
      description: "An evening of spontaneous worship and prophetic ministry",
      image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7"
    },
    {
      title: "Prophetic Conference",
      date: "April 20, 2024",
      time: "9:00 AM",
      location: "Conference Hall",
      description: "Developing sensitivity to the Holy Spirit's leading",
      image: "https://images.unsplash.com/photo-1519677584237-752f8853252e"
    },
    {
      title: "Spiritual Gifts Workshop",
      date: "May 5, 2024",
      time: "10:00 AM",
      location: "Training Center",
      description: "Understanding and operating in the gifts of the Spirit",
      image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65"
    }
  ];

  const features = [
    {
      icon: Wind,
      title: "Spirit-Led Life",
      description: "Learning to follow the Holy Spirit's guidance daily",
      color: "text-blue-400",
      gradient: "from-blue-600/20 to-blue-900/20",
      border: "border-blue-500/20"
    },
    {
      icon: Heart,
      title: "Divine Love",
      description: "Walking in supernatural love and compassion",
      color: "text-red-400",
      gradient: "from-red-600/20 to-red-900/20",
      border: "border-red-500/20"
    },
    {
      icon: Star,
      title: "Spiritual Gifts",
      description: "Operating in the gifts of the Spirit",
      color: "text-amber-400",
      gradient: "from-amber-600/20 to-amber-900/20",
      border: "border-amber-500/20"
    },
    {
      icon: Users,
      title: "Community",
      description: "Growing together in spiritual maturity",
      color: "text-purple-400",
      gradient: "from-purple-600/20 to-purple-900/20",
      border: "border-purple-500/20"
    }
  ];

  const benefits = [
    {
      icon: Zap,
      title: "Spiritual Power",
      description: "Experience the supernatural power of God"
    },
    {
      icon: BookOpen,
      title: "Biblical Foundation",
      description: "Solid teaching from God's Word"
    },
    {
      icon: Music2,
      title: "Prophetic Worship",
      description: "Enter God's presence through Spirit-led worship"
    },
    {
      icon: Sparkles,
      title: "Divine Encounters",
      description: "Personal encounters with the Holy Spirit"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >

      {/* Hero Section */}
      <div className="relative h-[50vh] mb-16">
        <div className="absolute inset-0">
          <img
            src={ImagesDev.litsImg}
            alt="Life in the Spirit"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40" />
        </div>
        <div className="relative container mx-auto px-4 h-full flex items-center">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">Life in the Spirit</h1>
            <p className="text-xl text-gray-300">Experience the supernatural life of walking in the Spirit</p>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative h-[70vh] mb-16 overflow-hidden">
        <motion.div
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0"
        >
          <img
            src="https://images.unsplash.com/photo-1519834089823-af2d966a0648"
            alt="Life in the Spirit"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80 backdrop-blur-sm" />
        </motion.div>

        <div className="relative container mx-auto px-4 h-full flex items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="max-w-3xl"
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              Live in the
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                {" "}Spirit
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
              Experience the supernatural life of walking in the Spirit and operating in divine power
            </p>
            <div className="flex flex-wrap gap-4">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full hover:from-blue-600 hover:to-purple-600 transition-colors shadow-lg"
              >
                Join Now
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-white/10 text-white rounded-full hover:bg-white/20 transition-colors"
              >
                Learn More
              </motion.button>
            </div>
          </motion.div>
        </div>

        {/* Floating Stats */}
        <div className="absolute bottom-0 left-0 right-0 transform translate-y-1/2">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { number: "5000+", label: "Lives Transformed" },
                { number: "100+", label: "Events Held" },
                { number: "30+", label: "Countries Reached" },
                { number: "24/7", label: "Spiritual Support" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 + index * 0.1 }}
                  className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/20"
                >
                  <h3 className="text-3xl font-bold text-blue-400 mb-2">{stat.number}</h3>
                  <p className="text-gray-300">{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {/* Features Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24 mt-16">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`bg-gradient-to-br ${feature.gradient} p-8 rounded-2xl backdrop-blur-sm border ${feature.border}`}
            >
              <feature.icon className={`w-12 h-12 ${feature.color} mb-6`} />
              <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-gray-300">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Benefits Grid */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Program Benefits</h2>
            <p className="text-xl text-gray-400">Experience transformation in every area of your life</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10"
              >
                <div className="flex items-start gap-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg">
                    <benefit.icon className="w-8 h-8 text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                    <p className="text-gray-300">{benefit.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Upcoming Events */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Upcoming Events</h2>
            <p className="text-xl text-gray-400">Join us for these transformative gatherings</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {events.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group relative overflow-hidden rounded-xl bg-white/5 backdrop-blur-sm border border-white/10"
              >
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{event.title}</h3>
                  <p className="text-gray-300 mb-4">{event.description}</p>
                  <div className="space-y-2 text-sm text-gray-300 mb-4">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-blue-400" />
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-blue-400" />
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="w-4 h-4 text-blue-400" />
                      <span>{event.location}</span>
                    </div>
                  </div>
                  <motion.button
                    whileHover={{ x: 5 }}
                    className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    Register Now
                    <ArrowRight className="w-4 h-4" />
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Event Highlights */}
        <EventsHighlights parent="life_in_the_spirit" />

        {/* Testimonials */}
        <LiveInTheSpiritComments />

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl"
        >
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
              alt="Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70 backdrop-blur-sm" />
          </div>

          <div className="relative p-12 md:p-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Ready to Walk in the Spirit?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Join our community and experience the supernatural life God has for you
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full hover:from-blue-600 hover:to-purple-600 transition-all duration-300 shadow-lg"
              >
                Start Your Journey
              </motion.button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}

function LiveInTheSpirit() {
  const [activeCard, setActiveCard] = useState(0);
  const [prayerRequest, setPrayerRequest] = useState('');

  const ministers_ = [
    {
      name: "Pastor David Wilson",
      role: "Lead Minister",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      focus: "Prophetic Ministry"
    },
    {
      name: "Sarah Thompson",
      role: "Worship Leader",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      focus: "Spirit-Led Worship"
    },
    {
      name: "Michael Chen",
      role: "Prayer Director",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      focus: "Intercessory Prayer"
    }
  ];

  const ministers = [
    { id: 1, name: "Pst. TitOluwa Olumideko", role: "Host & Lead Minister", image: ImagesDev.ministers.minTSO, focus: "Christocentric / Evangelical Ministry" },
    { id: 4, name: "Pastor Noble G.", role: "Colaborated Minister", image: ImagesDev.ministers.png, focus: "Christocentric / Spirit-Led Worship Ministry" },
    {
      id: 3, sub: true, ministers_: [
        { id: 1, name: "Pastor Lanre Olubaji", role: "Speaker", image: ImagesDev.ministers.pLanre, focus: "Christocentric Ministry" },
        { id: 1, name: "Pastor Yemi OLAKULEHIN", role: "Speaker", image: ImagesDev.ministers.pstYemi, focus: "Christocentric Ministry" },
        { id: 1, name: "Minister Samuel Giveson", role: "Speaker", image: ImagesDev.ministers.smj, focus: "Christocentric Ministry" },
        { id: 1, name: "Min. Mag Psalms", role: "Speaker", image: ImagesDev.ministers.magPsalm, focus: "Christocentric Ministry" },
      ]
    },
    // { id: 2, name: "Min. Mag Psalms", role: "Speaker", image: ImagesDev.ministers.magPsalm },
  ];

  const spiritualEncounters = [
    {
      title: "Divine Healing",
      testimony: "During our worship service, I felt the Holy Spirit's presence so strongly. My chronic pain of 5 years disappeared instantly!",
      author: "Rachel K.",
      location: "Lagos",
      date: "March 15, 2024"
    },
    {
      title: "Prophetic Word",
      testimony: "The specific word of knowledge about my situation was so accurate. It changed the course of my life.",
      author: "James M.",
      location: "Accra",
      date: "March 10, 2024"
    },
    {
      title: "Spiritual Breakthrough",
      testimony: "After months of spiritual dryness, I experienced a fresh baptism of the Holy Spirit during the conference.",
      author: "Sarah L.",
      location: "Abuja",
      date: "March 5, 2024"
    }
  ];

  const schedule = [
    {
      day: "1st Lits",
      events: [
        { time: "📅 28th, February 2025", title: "📍3C, OLAIDE BENSON CLOSE,", location: "Logic Church" },
        { time: "🕓 06:00 PM", title: "📍MARYLAND, LAGOS.", location: "MainLand" }
      ]
    },
    {
      day: "2nd Lits",
      events: [
        { time: "📅 30th, March 2025", title: "📍T.F KUBOYE ROAD, MARWA,", location: "LOGIC HQ" },
        { time: "🕓 05:00 PM", title: "📍LEKKI, LAGOS", location: "Island" }
      ]
    },
    {
      day: "Up Coming",
      events: [
        { time: "📅 Coming soon", title: "-----", location: "-----" },
        { time: "🕓 00:00 PM", title: "-----", location: "-----" }
      ]
    }
  ];

  const handlePrayerSubmit = (e) => {
    e.preventDefault();
    // Handle prayer request submission
    setPrayerRequest('');
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-800 to-black text-white pt-0 mb-[0px]"
    >
      {/* Interactive Hero Section */}
      <HeroSection />

      {/* Spiritual Encounters Section */}
      <div className="pt-24 pb-10 bg-gradient-to-b from-green-900/20 to-transparent">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-4">Spiritual Encounters</h2>
              <p className="text-xl text-gray-400">Real testimonies of lives transformed by the power of the Holy Spirit</p>
            </motion.div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {spiritualEncounters.map((encounter, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-2 bg-purple-500/20 rounded-lg">
                    <Flame className="w-6 h-6 text-orange-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">{encounter.title}</h3>
                    <p className="text-sm text-gray-400">{encounter.date}</p>
                  </div>
                </div>
                <blockquote className="text-gray-300 mb-4">"{encounter.testimony}"</blockquote>
                <div className="flex items-center justify-between text-sm text-gray-400">
                  <span>{encounter.author}</span>
                  <span>{encounter.location}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Meet the Ministers Section */}
      <div className="py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-4">Meet Our Ministers</h2>
              <p className="text-xl text-gray-400">Led by the Spirit, serving with passion</p>
            </motion.div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {ministers.map((minister, index) => (
              minister.sub ?
                <div className="grid grid-cols-2 gap-4">
                  {minister.ministers_.map((minister, index) => {
                    return (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.2 }}
                        className="group relative"
                      >
                        <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-600 to-gray-600 rounded-2xl blur opacity-75"></div>
                        <div className="relative bg-gray-900 rounded-xl overflow-hidden">
                          <div className="aspect-[3/4] relative overflow-hidden">
                            <img
                              src={minister.image}
                              alt={minister.name}
                              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                          </div>
                          <div className="absolute bottom-0 left-0 right-0 p-6">
                            <h3 className="text-md font-bold mb-1">{minister.name}</h3>
                            {/* <p className="text-amber-400 mb-2">{minister.role}</p> */}
                            {/* <p className="text-sm text-gray-300">{minister.focus}</p> */}
                          </div>
                        </div>
                      </motion.div>
                    )
                  })}
                </div>
                :
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="group relative"
                >
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-600 to-gray-600 rounded-2xl blur opacity-75"></div>
                  <div className="relative bg-gray-900 rounded-xl overflow-hidden">
                    <div className="aspect-[3/4] relative overflow-hidden">
                      <img
                        src={minister.image}
                        alt={minister.name}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-2xl font-bold mb-1">{minister.name}</h3>
                      <p className="text-amber-400 mb-2">{minister.role}</p>
                      <p className="text-sm text-gray-300">{minister.focus}</p>
                    </div>
                  </div>
                </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Prayer Wall Section */}
      <div className="pt-24 pb-10 bg-gradient-to-b from-blue-900/20 to-transparent">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-6">Prayer Wall</h2>
              <p className="text-xl text-gray-300 mb-8">
                Submit your prayer requests and join our community in intercession. Our team of prayer warriors is committed to standing with you in faith.
              </p>
              <form onSubmit={handlePrayerSubmit} className="space-y-4">
                <textarea
                  value={prayerRequest}
                  onChange={(e) => setPrayerRequest(e.target.value)}
                  placeholder="Share your prayer request..."
                  className="w-full h-32 px-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300 resize-none"
                />
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-600 to-amber-600 rounded-lg hover:from-orange-700 hover:to-amber-700 transition-all duration-300"
                >
                  <Send className="w-5 h-5" />
                  <span>Submit Prayer Request</span>
                </motion.button>
              </form>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="absolute -inset-4 bg-gradient-to-r from-amber-600/20 to-gray-600/20 rounded-3xl blur-xl"></div>
              <div className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <div className="flex items-center gap-4 mb-8">
                  <div className="p-3 bg-purple-500/20 rounded-lg">
                    <HelpingHand className="w-8 h-8 text-orange-400" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Prayer Statistics</h3>
                    <p className="text-gray-400">This week's prayer activity</p>
                  </div>
                </div>
                <div className="space-y-6">
                  {[
                    { label: "Prayer Requests Received", value: "127" },
                    { label: "Prayers Answered", value: "All" },
                    { label: "Active Prayer Warriors", value: "20+" },
                    { label: "Hours of Prayer", value: "168" }
                  ].map((stat, index) => (
                    <div key={index} className="flex justify-between items-center">
                      <span className="text-gray-300">{stat.label}</span>
                      <span className="text-2xl font-bold text-orange-400">{stat.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Event Schedule Section */}
      <div className="py-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold mb-4">Programs Schedule</h2>
              <p className="text-xl text-gray-400">Join us for these Spirit-filled gatherings</p>
            </motion.div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {schedule.map((day, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden border border-white/10"
              >
                <div className="bg-gradient-to-r from-amber-600/20 to-blue-600/20 p-4">
                  <h3 className="text-xl font-bold text-center">{day.day}</h3>
                </div>
                <div className="p-6 space-y-4">
                  {day.events.map((event, eventIndex) => (
                    <div key={eventIndex} className="space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="text-amber-400 font-medium">{event.time}</span>
                        <span className="text-sm text-gray-400">{event.location}</span>
                      </div>
                      <h4 className="text-lg font-medium">{event.title}</h4>
                      <div className="h-px bg-gradient-to-r from-amber-500/50 to-transparent"></div>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Event Highlights */}
      <div className='container mx-auto px-4'>
      <EventsHighlights parent="life_in_the_spirit" />
      </div>

      {/* Testimonials */}
      <div className='container mx-auto px-4'>
      <LiveInTheSpiritComments />
      </div>
    </motion.div>
  );
}





const LiveInTheSpiritComments = () => {
  const [comments, setComments] = useState([]);
  const [user, setUser] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageId, setPageId] = useState(null);
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [editingComment, setEditingComment] = useState(null);

  // Fetch Page ID by Slug
  useEffect(() => {
    const fetchPageId = async () => {
      try {
        const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/pages?slug=life-in-the-spirit`);
        const data = await response.json();
        if (data.length === 0) throw new Error("Page not found");
        setPageId(data[0].id);
      } catch (error) {
        console.error("Error fetching page ID:", error);
      }
    };

    fetchPageId();
  }, []);

  const fetchComments = async () => {
    if (!pageId) return;
    try {
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments?post=${pageId}`);
      const data = await response.json();
      setComments(data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (pageId) {
      fetchComments();
    }
  }, [pageId]);

  useEffect(() => {
    const loadUser = async () => {
      const userData = await getUserData();
      setUser(userData);
    };
    loadUser();
  }, []);

  const submitComment = async () => {
    if (!user || !user.id) return Toast.warning("You must be logged in to comment.");
    if (!comment.trim()) return Toast.warning("Comment cannot be empty.");
    if (!pageId) return Toast.warning("Page ID is not available yet. Please try again.");

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("https://tsoministries.com/wp-json/wp/v2/comments", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          post: pageId,
          content: comment,
          author: user.id,
        }),
      });

      if (!response.ok) throw new Error("Failed to post comment");

      setComment("");
      setShowCommentInput(false);
      fetchComments();
      Toast.success("Comment posted successfully!");
    } catch (error) {
      console.error("Error posting comment:", error);
      Toast.error("Failed to post comment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditComment = async (commentId) => {
    if (!user || !user.id) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments/${commentId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          content: editingComment.content,
        }),
      });

      if (!response.ok) throw new Error("Failed to update comment");

      setEditingComment(null);
      fetchComments();
      Toast.success("Comment updated successfully!");
    } catch (error) {
      console.error("Error updating comment:", error);
      Toast.error("Failed to update comment. Please try again.");
    }
  };

  const handleDeleteComment = async (commentId) => {
    if (!user || !user.id) return;

    if (!window.confirm("Are you sure you want to delete this comment?")) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments/${commentId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to delete comment");

      fetchComments();
      Toast.success("Comment deleted successfully!");
    } catch (error) {
      console.error("Error deleting comment:", error);
      Toast.error("Failed to delete comment. Please try again.");
    }
  };

  return (
    <div className="pb-16">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold">Testimonials</h2>
        {user && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowCommentInput(!showCommentInput)}
            className="flex items-center space-x-2 px-4 py-2 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            <span>Share Your Testimony</span>
          </motion.button>
        )}
      </div>

      {/* Comment Input */}
      <AnimatePresence>
        {showCommentInput && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="mb-8"
          >
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={user?.avatar_url || "/default-avatar.png"}
                  alt={user?.name}
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <p className="font-semibold">{user?.name}</p>
                  <p className="text-sm text-gray-400">Sharing your testimony</p>
                </div>
              </div>
              <textarea
                className="w-full p-4 bg-black/30 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300 resize-none"
                rows="4"
                placeholder="Share your healing testimony..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <div className="flex justify-end space-x-4 mt-4">
                <button
                  onClick={() => setShowCommentInput(false)}
                  className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={submitComment}
                  disabled={loading}
                  className="flex items-center space-x-2 px-4 py-2 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50"
                >
                  <Send className="w-4 h-4" />
                  <span>{loading ? "Posting..." : "Post Testimony"}</span>
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Comments Grid */}
      <div className="grid md:grid-cols-3 gap-8">
        {comments.map((comment) => (
          <motion.div
            key={comment.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10 relative group"
          >
            <div className="flex items-center space-x-4 mb-4">
              <img
                src={comment.author_avatar_urls?.[48] || "/default-avatar.png"}
                alt={comment.author_name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h3 className="font-bold">{comment.author_name}</h3>
                <p className="text-sm text-gray-400">
                  {new Date(comment.date).toLocaleDateString()}
                </p>
              </div>
            </div>

            {editingComment?.id === comment.id ? (
              <div className="space-y-4">
                <textarea
                  className="w-full p-3 bg-black/30 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                  value={editingComment.content}
                  onChange={(e) => setEditingComment({
                    ...editingComment,
                    content: e.target.value
                  })}
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setEditingComment(null)}
                    className="px-3 py-1 rounded-lg hover:bg-white/10 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleEditComment(comment.id)}
                    className="px-3 py-1 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors"
                  >
                    Save
                  </button>
                </div>
              </div>
            ) : (
              <p className="text-gray-300">{
                <div
                  className="text-gray-300"
                  dangerouslySetInnerHTML={{ __html: comment.content.rendered }}
                />}</p>
            )}

            {user && user.id === comment.author && !editingComment && (
              <div className="absolute top-4 right-4 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => setEditingComment({
                    id: comment.id,
                    content: comment.content.rendered
                  })}
                  className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                >
                  <Edit2 className="w-4 h-4" />
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => handleDeleteComment(comment.id)}
                  className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </motion.button>
              </div>
            )}
          </motion.div>
        ))}
      </div>

      {!user && (
        <>
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mt-12 bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10"
        >
          <h2 className="text-3xl font-bold mb-4">Life in the Spirit! Where you there?</h2>
          <p className="text-xl text-gray-300 mb-8">
            Share your testimony and let your story uplift, encourage, and ignite faith in others.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => { window.location.href = "/register" }}
            className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-full hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg"
          >
            Register Now
          </motion.button>
        </motion.div> */}
        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl"
        >
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
              alt="Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70 backdrop-blur-sm" />
          </div>

          <div className="relative p-12 md:p-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Life in the Spirit! Where you there?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Share your testimony and let your story uplift, encourage, and ignite faith in others.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => { window.location.href = "/register" }}
                className="px-8 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-full hover:from-orange-600 hover:to-amber-600 transition-all duration-300 shadow-lg"
              >
                Start Your Journey
              </motion.button>
            </motion.div>
          </div>
        </motion.div>
        </>
      )}
    </div>
  );
};

const cards = [
  {
    title: "Walk in the Spirit",
    description:
      "Experience the transformative power of living a Spirit-led life through divine guidance and supernatural encounters.",
    image: ImagesDev.litsImg2
  },
  {
    title: "Experience Power",
    description:
      "Step into the realm of God's power through prophetic ministry, healing, and spiritual gifts.",
    image: ImagesDev.litsImg
  },
  {
    title: "Live Supernaturally",
    description:
      "Discover the supernatural life that God has prepared for you through intimate fellowship with the Holy Spirit.",
    image: ImagesDev.litsImg3
  }
];

function HeroSection_() {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef(null);
  const prevIndex = (activeIndex - 1 + cards.length) % cards.length;
  const nextIndex = (activeIndex + 1) % cards.length;

  // Autoplay
  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, []);
  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, [activeIndex]);

  const startAutoPlay = () => {
    stopAutoPlay();
    intervalRef.current = setInterval(() => {
      goToNext();
    }, 6000); // 6s
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % cards.length);
  };

  const goToPrev = () => {
    setActiveIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const handleSwipe = (dir) => {
    dir === "left" ? goToNext() : goToPrev();
  };

  return (
    <div
      className="relative h-[80vh] w-full px-4 pt-[14vh] relative bg-black"
      // onMouseEnter={stopAutoPlay}
      // onMouseLeave={startAutoPlay}
      onTouchStart={stopAutoPlay}
      onTouchEnd={startAutoPlay}
    >

      {/* Row of cards */}
      <div className="absolute h-[80vh] w-full top-0 left-0 right-0 flex justify-center gap-1 md:gap-4 z-0 opacity-40">
        {/* Previous Card */}
        <div
          className="w-[50%] h-[80vh] cursor-pointer rounded-xl overflow-hidden shadow-md transition-all"
          onClick={() => setActiveIndex(prevIndex)}
        >
          <motion.div
            key={`prev-${prevIndex}`}
            initial={{ x: -80, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 80, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="aspect-[4/3] h-[80vh] relative"
          >
            <img
              src={cards[prevIndex].image}
              alt={cards[prevIndex].title}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
            <div className="absolute bottom-0 p-4 text-white">
              {/* <h3 className="font-semibold text-lg">{cards[prevIndex].title}</h3> */}
            </div>
          </motion.div>
        </div>

        {/* Next Card */}
        <div
          className="w-[50%] h-[80vh] cursor-pointer rounded-xl overflow-hidden shadow-md transition-all"
          onClick={() => setActiveIndex(nextIndex)}
        >
          <motion.div
            key={`next-${nextIndex}`}
            initial={{ x: 80, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -80, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="aspect-[4/3] h-[80vh] relative"
          >
            <img
              src={cards[nextIndex].image}
              alt={cards[nextIndex].title}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
            <div className="absolute bottom-0 p-4 text-white">
              {/* <h3 className="font-semibold text-lg">{cards[nextIndex].title}</h3> */}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Active Card */}
      <div className='relative' style={{ zIndex: 10 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={activeIndex}
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -100, opacity: 0 }}
            transition={{ duration: 0.5 }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={(e, info) => {
              if (info.offset.x < -50) handleSwipe("left");
              else if (info.offset.x > 50) handleSwipe("right");
            }}
            className="relative mb-12 max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-xl cursor-grab active:cursor-grabbing"
          >
            <div className="relative h-[28rem] md:h-[32rem]">
              <img
                src={cards[activeIndex].image}
                alt={cards[activeIndex].title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
              <div className="absolute bottom-0 p-6 text-white">
                <h2 className="text-2xl md:text-3xl font-bold mb-2">
                  {cards[activeIndex].title}
                </h2>
                <p className="text-gray-300">{cards[activeIndex].description}</p>
              </div> */}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Buttons */}
      {/* <div className="flex justify-center gap-4 mb-8">
        <button
          onClick={goToPrev}
          className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
        >
          Prev
        </button>
        <button
          onClick={goToNext}
          className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
        >
          Next
        </button>
      </div> */}
    </div>
  );
}

function HeroSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef(null);
  const prevIndex = (activeIndex - 1 + cards.length) % cards.length;
  const nextIndex = (activeIndex + 1) % cards.length;

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, []);

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, [activeIndex]);

  const startAutoPlay = () => {
    stopAutoPlay();
    intervalRef.current = setInterval(() => {
      goToNext();
    }, 6000);
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % cards.length);
  };

  const goToPrev = () => {
    setActiveIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const handleSwipe = (dir) => {
    dir === "left" ? goToNext() : goToPrev();
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-gray-900 via-amber-900/20 to-black overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 opacity-10 blur-sm" style={{ background: `url(${ImagesDev.heroImages[9]})`, backgroundRepeat: "repeat", filter: "sepia(100%) saturate(200%) brightness(70%) hue-rotate(330deg)" }}></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(139,92,246,0.15)_0,rgba(139,92,246,0)_70%)] animate-pulse-slow backdrop-blur-md"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(236,72,153,0.15)_0,rgba(236,72,153,0)_70%)] animate-pulse-slow animation-delay-2000"></div>
        {/* filter: "sepia(100%) saturate(200%) brightness(70%) hue-rotate(330deg)" */}
      </div>

      <div className="relative container mx-auto px-4 pt-24 pb-12">

        {/* Cards Section */}
        <div className="relative h-[70vh] md:h-[80vh]">
          {/* Background Cards */}
          <div className="absolute inset-0 flex justify-center items-center gap-4 opacity-40">
            <motion.div
              key={`prev-${prevIndex}`}
              initial={{ x: -80, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 80, opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="hidden md:block w-1/3 h-[60vh] rounded-2xl overflow-hidden cursor-pointer transform -rotate-12 hover:rotate-0 transition-transform duration-300"
              onClick={() => setActiveIndex(prevIndex)}
            >
              <div className="relative h-full">
                <img
                  src={cards[prevIndex].image}
                  alt={cards[prevIndex].title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
              </div>
            </motion.div>

            <motion.div
              key={`next-${nextIndex}`}
              initial={{ x: 80, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -80, opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="hidden md:block w-1/3 h-[60vh] rounded-2xl overflow-hidden cursor-pointer transform rotate-12 hover:rotate-0 transition-transform duration-300"
              onClick={() => setActiveIndex(nextIndex)}
            >
              <div className="relative h-full">
                <img
                  src={cards[nextIndex].image}
                  alt={cards[nextIndex].title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
              </div>
            </motion.div>
          </div>

          {/* Active Card */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeIndex}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="relative max-w-2xl mx-auto h-full"
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              onDragEnd={(e, info) => {
                if (info.offset.x < -50) handleSwipe("left");
                else if (info.offset.x > 50) handleSwipe("right");
              }}
            >
              <div className="relative h-full rounded-2xl overflow-hidden shadow-2xl shadow-purple-500/20 cursor-grab active:cursor-grabbing group">
                <img
                  src={cards[activeIndex].image}
                  alt={cards[activeIndex].title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />

                <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-12">
                  <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    className="relative z-10"
                  >
                    <h2 className="text-3xl md:text-4xl font-bold mb-4">
                      {cards[activeIndex].title}
                    </h2>
                    <p className="text-lg md:text-xl text-gray-300">
                      {cards[activeIndex].description}
                    </p>
                    {/* <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="mt-6 px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-medium hover:from-purple-700 hover:to-pink-700 transition-all duration-300"
                    >
                      Learn More
                    </motion.button> */}
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Indicators */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {cards.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${index === activeIndex
                    ? 'w-8 bg-amber-500'
                    : 'bg-white/30 hover:bg-white/50'
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Title Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-bold mt-6">
            Life in the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
              Spirit
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Experience the supernatural life of walking in the Spirit
          </p>
        </motion.div>
      </div>
    </div>
  );
}


export default LiveInTheSpirit